<div class="modal fade show agenda-item-modal" [class.liveView]="liveView" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">
          {{ 'meetings.AgendaItem' | translate }}
          <ng-container *ngIf="item.madicalCases">[{{'case.Case' | translate}}]</ng-container>
        </h4>

        <div *ngIf="item.canEdit" class="d-inline-block tableOptions-container">
          <button class="btn btn-outline-primary pt-0" [matMenuTriggerFor]="menu">
            <svg width="24" height="6" viewBox="0 0 24 6">
              <path id="show-actions-menu-btn"
                d="M5610.879,13616.122a3,3,0,1,1,2.121.879A3,3,0,0,1,5610.879,13616.122Zm-9,0a3,3,0,1,1,2.121.879A3,3,0,0,1,5601.878,13616.122Zm-9,0a3,3,0,1,1,2.121.879A3,3,0,0,1,5592.878,13616.122Z"
                transform="translate(-5592 -13611.001)" fill="#666" />
            </svg>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)='openEditModal = true'>
              <svg width="18" height="18.004" viewBox="0 0 18 18.004">
                <path id="edit-icon"
                  d="M6.524,15.751,2.44,11.668l9.877-9.877L16.4,5.874ZM2.058,12.387,5.8,16.133.188,18Zm15.6-7.763-.708.708L12.859,1.243l.708-.708a1.827,1.827,0,0,1,2.584,0L17.657,2.04a1.837,1.837,0,0,1,0,2.584Zm0,0"
                  transform="translate(-0.188 0.001)" fill="#92bcd2" />
              </svg>
              <span>{{ 'users.Edit' | translate }}</span>
            </button>
            <button mat-menu-item (click)='DeleteAgendaItem()'>
              <svg width="14.997" height="20" viewBox="0 0 14.997 20">
                <path id="delete-icon"
                  d="M5615.926,13481a3.242,3.242,0,0,1-3.238-3.238v-10.507a.673.673,0,0,1,.672-.673h12.275a.673.673,0,0,1,.672.673v10.507a3.242,3.242,0,0,1-3.239,3.238Zm5.188-10.367v6.316a.826.826,0,0,0,1.653,0v-6.316a.826.826,0,0,0-1.653,0Zm-4.886,0v6.316a.826.826,0,0,0,1.653,0v-6.316a.826.826,0,0,0-1.653,0Zm-3.807-4.824a.423.423,0,0,1-.422-.423v-1.3a2.036,2.036,0,0,1,2.035-2.034h2.93v-.254a.793.793,0,0,1,.792-.793h3.483a.793.793,0,0,1,.792.793v.254h2.93a2.036,2.036,0,0,1,2.035,2.034v1.3a.423.423,0,0,1-.422.423Z"
                  transform="translate(-5612 -13461)" fill="#92bcd2" />
              </svg>
              <span> {{ 'users.Delete' | translate }}</span>
            </button>
          </mat-menu>
        </div>
        <button type="button" class="close" aria-label="Close" (click)="closePop()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf='loadingData' class="dataLoading">
          <mat-spinner class="m-auto" diameter="50"></mat-spinner>
        </div>

        <ng-container *ngIf='!loadingData'>
          <div class="agenda-list">

            <!-- Agenda details -->
            <div class="agenda-item" *ngIf="!item.madicalCases">
              <div class="title">
                <span class="badge badge-secondary">{{item.itemOrder}}</span>
                <h3>{{item.title}}</h3>
              </div>
            </div>

            <div class="agenda-item case" *ngIf="item.madicalCases">
              <div class="title">
                <span class="badge badge-secondary">{{item.itemOrder}}</span>
              </div>
              <div class="case-details">
                <div class="d-flex align-items-center">
                  <span class="badge blue large"><span>{{'case.MRN' | translate}}:</span>{{item.madicalCases.mrn}}</span>
                  <span class="sep">|</span>
                  <span class="span-info">{{'case.National ID' | translate}}: <b>{{item.madicalCases.nationalId}}</b></span>
                </div>
                <div>
                  <h2>{{item.madicalCases.pationtName}}</h2>
                </div>
                <div>
                  <span class="span-info">{{'studyList.Gender' | translate}}:
                    <b>{{'agendaCase.' + item.madicalCases.gender | translate}}</b>
                  </span>
                  <span class="span-info">{{'fields.dateBirth' | translate}}:
                    <b>{{item.madicalCases.dateOfBirth | date}}</b>
                  </span>
                </div>
                <div>
                  <span class="span-info">{{'case.Diagnosis' | translate}}: <span class="badge-dark-blue">{{item.madicalCases.diagnosis}}</span></span>
                </div>
                <div>
                  <span class="span-info">{{'case.Referred from' | translate}}:
                    <strong>{{item.madicalCases.referredFrom}}</strong>
                  </span>
                </div>
              </div>
            </div>
            <!-- End Agenda details -->

          </div>

          <!-- Agenda item tabs -->
           <!-- Case tabs -->
          <ng-container *ngIf="item.madicalCases">
            <div class="tabs-section case">
              <mat-tab-group class="mat-tabs-primary" [selectedIndex]="selectedIndex">
                <mat-tab [label]="'agendaCase.Clinical Visits' | translate">
                  <app-clinical-visits [meetingAgendaItemId]="item?.agendaItemEntityId" [meetingId]="meeting.meetingId" [liveView]='liveView'></app-clinical-visits>
                </mat-tab>
                <mat-tab [label]="'agendaCase.Lab Test Results' | translate">
                  <app-lab-test-results [meetingAgendaItemId]="item?.agendaItemEntityId" [meetingId]="meeting.meetingId" [liveView]='liveView'></app-lab-test-results>
              </mat-tab>

              <mat-tab [label]="'agendaCase.Radiology' | translate">
                  <app-study-list [meetingAgendaItemId]="item?.agendaItemEntityId" [meetingId]="meeting.meetingId" [liveView]='liveView'></app-study-list>
              </mat-tab>

              <mat-tab [label]="'agendaCase.Pathology' | translate">
                  <app-slides-list [meetingAgendaItemId]="item?.agendaItemEntityId" [meetingId]="meeting.meetingId" [liveView]='liveView'></app-slides-list>
              </mat-tab>

              <mat-tab [label]="'agendaCase.Surgery' | translate">
                  <app-surgery [meetingAgendaItemId]="item?.agendaItemEntityId" [meetingId]="meeting.meetingId"  [liveView]='liveView'></app-surgery>
              </mat-tab>
                <mat-tab [label]="'case.Treatment Plan' | translate">
                  <app-treatment-list [item]="item"></app-treatment-list>
                </mat-tab>
                <mat-tab [label]="'meetings.Recommendations' | translate">
                  <app-case-recommendations [item]="item"></app-case-recommendations>
                </mat-tab>
              </mat-tab-group>
            </div>
          </ng-container>

          <!-- Normal agenda tabs -->
          <ng-container *ngIf="!item.madicalCases">
            <div class="tabs-section">
              <mat-tab-group class="mat-tabs-primary" [selectedIndex]="selectedIndex">
                <mat-tab [label]="'meetings.Attachments' | translate">
                  <app-files-viewer class="one-col" *ngIf="item.attachments.length" [files]='item.attachments'>
                  </app-files-viewer>
                  <div class="no-document" *ngIf="!item.attachments.length">
                    <img src="./assets/images/no-attachments-illustration.png" alt="">
                    <p>{{ 'meetings.Noattachmentsadded' | translate }}</p>
                  </div>
                </mat-tab>

                <mat-tab [label]="'messagesCom.Comments' | translate">
                  <div class="message-comments-container" *ngIf="commentsResult && commentsResult.pageData.length">
                    <div class="comments-list">
                      <div class="comment-panel" *ngFor="let oneComment of commentsResult.pageData; index as i;">
                        <div class="reply-header d-sm-flex justify-content-between align-items-center">

                          <div class="name-with-image mb-3 mb-sm-0"
                            *ngIf="oneComment.creatorData && oneComment.creatorData.creatorId">
                            <div class="image-circle" [title]="oneComment.creatorData.creatorName">
                              <img *ngIf="oneComment.creatorData.creatorProfilePicture"
                                [src]="oneComment.creatorData.creatorProfilePicture"
                                (error)="oneComment.creatorData.creatorProfilePicture = ''" />
                              <span *ngIf="!oneComment.creatorData.creatorProfilePicture">{{
                                oneComment.creatorData.creatorName | shortName }}</span>
                            </div>
                            <div class="name">
                              <h5>
                                {{oneComment.creatorData.creatorName}}<span>({{oneComment.creatorData.creatorUserName}})</span>
                              </h5>
                              <h6>{{oneComment.creatorData.creatorCollectionName}}</h6>
                            </div>
                            <div class="delegated-user"
                              *ngIf="oneComment.delegatorData && oneComment.delegatorData.creatorId">
                              <img class="delegated-arrow" src="./assets/images/icons/arrow-delegate-icon.svg">
                              <div class="image-circle" [title]="oneComment.delegatorData.creatorName">
                                <img *ngIf="oneComment.delegatorData.creatorProfilePicture"
                                  [src]="oneComment.delegatorData.creatorProfilePicture"
                                  (error)="oneComment.delegatorData.creatorProfilePicture = ''" />
                                <span *ngIf="!oneComment.delegatorData.creatorProfilePicture">{{
                                  oneComment.delegatorData.creatorName | shortName }}</span>
                              </div>
                              <div class="creatorName pl-2" *ngIf="oneComment.delegatorData.creatorName">
                                ({{oneComment.delegatorData.creatorName}})
                              </div>
                            </div>
                          </div>

                          <div class="text-lg-right">
                            <p class="date-time">{{oneComment.created | date:'MMMM dd, hh:mm aaa'}}</p>
                            <p class="time-from">{{oneComment.created | timeAgo}}</p>
                          </div>
                        </div>
                        <div class="reply-content"
                          [ngClass]="{'agenda-delegator has-delegator': oneComment.delegatorData && oneComment.delegatorData.creatorId}">
                          <div class="reply-body">
                            {{oneComment.content}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="no-document" *ngIf="!commentsResult || !commentsResult.pageData.length">
                    <img src="./assets/images/icons/no-comments.svg" alt="">
                    <p> {{ 'meetings.Nocommentsadded' | translate }}</p>
                  </div>
                </mat-tab>

                <mat-tab [label]="'meetings.Voting' | translate">
                  <app-meeting-vote [item]='item' [meeting]='meeting' [liveView]='liveView'
                    (openTaskForm)='openCreateTask($event)' (selectedTab)='getAgendItemDetails(); selectedIndex = 2'>
                  </app-meeting-vote>
                </mat-tab>

                <mat-tab [label]="'meetings.Recommendations' | translate" *ngIf="item.showRecommendation">
                  <div class="recommendations">
                    <h4 class="main-title">{{ 'meetings.MyRecommendations' | translate }}</h4>

                    <div class="items-list-container active">
                      <div *ngIf='recommendsLoader' class="dataLoading">
                        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
                      </div>
                      <div class="items-list" *ngIf='!recommendsLoader'>
                        <!-- cdkDropList (cdkDropListDropped)="drop($event)" -->
                        <div>
                          <!-- cdkDrag -->
                          <div *ngFor="let item of terms; index as i;" class="terms-control"
                            [ngClass]='{"loading black": recommendsDeleteId == item.recommendationId}'>
                            <!-- <span class="drag-me" cdkDragHandle>
                                                        <svg width="6" height="10.001" viewBox="0 0 6 10.001">
                                                            <path id="drag-drop-icon"
                                                                d="M4884.5,8787a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm4-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm4-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z"
                                                                transform="translate(-4880 -8777)" fill="#aaa" />
                                                        </svg>
                                                    </span> -->
                            <span class="list-icon">
                              <svg width="14" height="14" viewBox="0 0 14 14">
                                <path id="listing-icon"
                                  d="M3.809,6l-.33.329a.46.46,0,0,0,0,.651l2.5,2.5a.461.461,0,0,0,.651,0L12.99,3.125a.46.46,0,0,0,0-.651l-.33-.329a.461.461,0,0,0-.651,0L6.633,7.515a.461.461,0,0,1-.651,0L4.46,6A.461.461,0,0,0,3.809,6Zm9.248,1a.46.46,0,0,0-.459.425A5.606,5.606,0,1,1,7.008,1.4a5.524,5.524,0,0,1,1.3.146.462.462,0,0,0,.433-.122l.388-.388A.46.46,0,0,0,8.912.265,7.643,7.643,0,0,0,7.008,0,7,7,0,1,0,14,7.5a.461.461,0,0,0-.459-.5Z"
                                  fill="#aaa" />
                              </svg>
                            </span>
                            <div>
                              <!-- <textarea disabled placeholder="Add a recommendation..." class="form-control"
                                                            [(ngModel)]="item.title"
                                                            (keyup)="textAreaAdjust($event); updateListItem(i, $event)"
                                                            (focus)="textAreaAdjust($event)"
                                                            [ngModelOptions]="{standalone: true}" maxlength="250"></textarea> -->
                              <div class="form-control">{{item.title}}</div>
                            </div>
                            <div class="actions">
                              <button class="btn" *ngIf="item.canCreateTask" (click)="openCreateTask(item.title)">
                                <img src="./assets/images/icons/add-new-task-icon.svg" alt="">
                              </button>
                              <button class="btn" (click)="removeListItem(i, item.recommendationId)"
                                *ngIf="item.canDelete">
                                <img src="./assets/images/icons/delete-icon.svg" alt="">
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="terms-control" [ngClass]='{"loading black": itemLoading}'>
                        <!-- <span class="drag-me">
                                <svg width="6" height="10.001" viewBox="0 0 6 10.001">
                                    <path id="drag-drop-icon"
                                        d="M4884.5,8787a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm4-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm4-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z"
                                        transform="translate(-4880 -8777)" fill="#aaa" />
                                </svg>
                            </span> -->
                        <span class="list-icon">
                          <svg width="14" height="14" viewBox="0 0 14 14">
                            <path id="listing-icon"
                              d="M3.809,6l-.33.329a.46.46,0,0,0,0,.651l2.5,2.5a.461.461,0,0,0,.651,0L12.99,3.125a.46.46,0,0,0,0-.651l-.33-.329a.461.461,0,0,0-.651,0L6.633,7.515a.461.461,0,0,1-.651,0L4.46,6A.461.461,0,0,0,3.809,6Zm9.248,1a.46.46,0,0,0-.459.425A5.606,5.606,0,1,1,7.008,1.4a5.524,5.524,0,0,1,1.3.146.462.462,0,0,0,.433-.122l.388-.388A.46.46,0,0,0,8.912.265,7.643,7.643,0,0,0,7.008,0,7,7,0,1,0,14,7.5a.461.461,0,0,0-.459-.5Z"
                              fill="#aaa" opacity="0.5" />
                          </svg>
                        </span>
                        <!-- item.editRecommendation -->
                        <div *ngIf="item.editRecommendation">
                          <textarea [placeholder]="'meetings.AddRecommendation' | translate" class="form-control"
                            [(ngModel)]="listItem" (keyup)="textAreaAdjust($event)" (focus)="textAreaAdjust($event)"
                            (keydown.enter)="addListItem($event)" [ngModelOptions]="{standalone: true}"
                            maxlength="250"></textarea>
                        </div>
                      </div>
                    </div>

                  </div>
                </mat-tab>

                <mat-tab [label]="'meetings.Linked Slide(s)' | translate" *ngIf="item.pathologySlides.length">
                  <app-slides-listing-view [agendaItemId]='item.agendaItemEntityId' [liveView]='liveView'
                    [slides]="item.pathologySlides" (slideUnlinked)="slideUnlinked($event)">
                  </app-slides-listing-view>
                </mat-tab>

              </mat-tab-group>
            </div>
          </ng-container>
          <!-- End Agenda item tabs -->

        </ng-container>
      </div>
    </div>
  </div>
</div>

<app-agenda-form *ngIf="openEditModal && item && item.agendaItemEntityId" [item]='item'
  (cancelPop)='openEditModal = false' (closePopAndSave)='saveItemSucsses($event)'></app-agenda-form>

<app-create-edit-task *ngIf='openTaskForm' [taskId]="-1" [taskType]="0" [taskTitle]="taskTitle"
  [groupId]="meeting.groupDetails.groupId" [groupAbbreviation]="meeting.groupDetails.groupArabicName"
  (closePopAndSave)="openTaskForm = false" (cancelPop)='openTaskForm = false'></app-create-edit-task>
